define('models/customer',['require','backbone','models/country','models/state','models/city','models/phone_number','models/customer_chain','models/customer_manager','models/reseller'],function(require){

    var Backbone = require('backbone');

    var CountryModel = require('models/country');
    var StateModel = require('models/state');
    var CityModel = require('models/city');
    var PhoneNumberModel = require('models/phone_number');
    var CustomerChainModel = require('models/customer_chain');
    var CustomerManagerModel = require('models/customer_manager');
    var ResellerModel = require('models/reseller');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'customers/' + this.id + '/' ) :
                ( App.Config.apiBase + 'customers/' );
        },

        defaults: function () {
            return {
                id: null,
                reseller: 0,
                license_email: '',
                company_legal_name: '',
                company_name: '',
                chain: null,
                chain_name: '',
                sector: null,
                phone_number: new PhoneNumberModel().attributes,
                phone_country: null,
                phone_value: '',
                tax_office: '',
                tax_number: '',
                country: null,
                state: null,
                city_name: '',
                currency: '',
                district: '',
                address: '',
                re_branding_brand: '',
                manager_object: new CustomerManagerModel().attributes,
                reseller_object: new ResellerModel().attributes,
                city_object: new CityModel().attributes,
                country_object: new CountryModel().attributes,
                state_object : new StateModel().attributes,
                chain_object: new CustomerChainModel().attributes,
                status: 2
            };
        }
    });
});
